module.exports = __webpack_public_path__ + "assets/img/message.7b727f0f.svg";